import { useEffect } from "react";

import { authClient } from "~/lib/auth";
import { isImpersonationSession, setSupportViewActive } from "~/lib/impersonation";
import { op } from "~/lib/openpanel";

/**
 * Keeps the support-view flag in sync with the session so OpenPanel / Awin
 * helpers can no-op without reading React state.
 */
export function useSupportViewGate(): void {
  const { data: session } = authClient.useSession();

  useEffect(() => {
    const active = isImpersonationSession(session);
    setSupportViewActive(active);
    if (active) {
      op.clear();
    }
  }, [session]);
}
